module.exports = __webpack_public_path__ + "static/media/cell_icon_default.069d586a.jpg";